/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Partner_Settings_Language_DescriptionInputs */



/**
* | output |
* | --- |
* | "The language used across the portal." |
*
* @param {Partner_Settings_Language_DescriptionInputs} inputs
* @param {{ locale?: "en" | "de" }} options
* @returns {LocalizedString}
*/
export const partner_settings_language_description = /** @type {((inputs?: Partner_Settings_Language_DescriptionInputs, options?: { locale?: "en" | "de" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Partner_Settings_Language_DescriptionInputs, { locale?: "en" | "de" }, {}>} */ ((inputs = {}, options = {}) => {
	void inputs;
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "de") return /** @type {LocalizedString} */ ("Die im Portal verwendete Sprache.")
	return /** @type {LocalizedString} */ ("The language used across the portal.")
});